export default {
	configTasks: {
		add: "Add",
		addTask: "Create a task",
		editTask: "Edit Task",
		editParams: "Edit Parameters",
		delete: "Delete",
		view: "View",
		compact: "Optimal",
		full: "Full",
		export: "Export",
		insert: "Insert",
		insertTooltip: "Script of adding tasks",
		delete: "Delete",
		deleteTooltip: "Script of task deletion",
		deleteWarning: "This action will delete this task",
		noTasksError: "No task selected",
		attention: "Attention",
		cancel: "Cancel",
		taskDeleted: "Task deleted, check Cron",
		paramsEdited: "Parameters changed, please check Cron",
		yes: "Yes",
		no: "No"
	},
	configTree: {
		selectActionWithBase: "Select action with base:",
		untieBaseAndDelete: "Unlink the base from the application and delete",
		untieBase: "Unlink base from application",
		untieBaseFromAllAppsAndDelete: "Unbind the base from all applications and delete",
		untieBaseFromAllApps: "Untie base from all applications",
		cancel: "Cancel",
		selectActionWithApp: "Select action with application:",
		linkedBasesNumber: "All linked bases: ",
		selectBaseToUnselect: "Select the bases to unbind from the application:",
		unlinkSelectedBases: "Unlink the selected bases from the application",
		selectAllBases: "Select all bases",
		unselectAllBases: "Unselect all bases",
		noLinkedBases: "No databases are linked to this application",
		deleteApp: "Delete application",
		enterData: "Enter the data of the new application. Copied:",
		attentionAppCopy: "Attention: the application is copied within the same server",
		name: "Name",
		alias: "Alias",
		path: "Path",
		add: "Add",
		fastCreate: "Fast base creation",
		copy: "Copy",
		edit: "Edit",
		delete: "Delete",
		refreshData: "Refresh Data",
		refreshServerSynchrDate: "Refresh server synchronization date",
		createServer: "Create Server",
		exportManagerCfg: "Export manager.cfg",
		importManagerCfg: "View manager.cfg",
		export: "Export",
		exportManagerQuestion: "Export manager.cfg?",
		exportManagerQuestion: "Create manager.cfg?",
		managerFileChanged: "Manager.cfg is changed. File edit: {fileDate}, base export: {baseDate}",
		managerFileUnchanged: "Rewrite the file manager.cfg? file edit: {fileDate}, base export: {baseDate}",
		enterNewAppName: "Enter the name of the new application",
		enterNewPath: "Enter the path of the new application",
		enterNameForBaseFastCreate: "Enter the name of the base for quick creation (other default values)",
		back: "Back",
		wrongFormat: "Invalid input format",
		checkAccess: "Check user permissions for this connection. Access is denied by default",
		desirableEnterAlias: "It is desirable to fill in the 'Alias' field. Continue without filling?",
		attention: "Attention",
		continue: "Continue",
		comeback: "Return",
		thisActionDeleteServer: "This action will delete this server:",
		cancellation: "Cancel",
		paramDeleteAction: "This action will remove this application parameter:",
		usersPermissionsDeleted: "User permissions have been removed for this link",
		operationNotSelected: "No operation selected",
		selectAppForUnlink: "Select an application to unlink",
		selectBaseForUnlink: "Select a base to unlink",
		selectOperation: "Select an operation",
		checkUsersAccessForThisLink: "Check user permissions for this link. Access is denied by default",
		checkAddOK: "Check addOk in Config Tree Node",
		serverNotSelected: "No server selected",
		noTinyAgentOnServer: "There is no tiny agent on the server",
	},
	roleSections: {
		role: "Role:",
		allow: "Allow",
		prohibit: "Deny",
		view: "View",
		compact: "Optimal",
		full: "Full",
		tableHeaders: {
			access: "Access",
			available: "Available",
			base: "Base",
			baseAlias: "Base Alias",
			baseComment: "Comment to the base",
			app: "Application",
			appAlias: "Application Alias",
			appServer: "Application Server"
		}
	},
	roleTasks: {
		role: "Role:",
		allow: "Allow",
		prohibit: "Deny",
		view: "View",
		compact: "Optimal",
		full: "Full",
		tableHeaders: {
			access: "Access",
		}
	},
	sectionTasks: {
		server: "Server:",
		app: "Application",
		appNotSelected: "No application selected",
		launchAllowed: "Launch allowed",
		launchDenied: "Launch denied",
		deniedLaunch: "Deny Launch",
		allowLaunch: "Allow Launch",
	}
};